import { track, trackOnce } from './funnel.js';
import { PREVIEW_EVENT_NAMES } from './freePreview.js';

const KNOWN = new Set(PREVIEW_EVENT_NAMES);

export function trackPreview(name, props = {}) {
  if (!KNOWN.has(name)) return;
  try { track(name, props); } catch { /* fail-silent */ }
}
export function trackPreviewOnce(name, props = {}, scopeKey) {
  if (!KNOWN.has(name)) return;
  try { trackOnce(name, props, scopeKey); } catch { /* fail-silent */ }
}
